<template>
	<div id="body-container">
		<NavBar :class="{active:'bg-dark'}"/>
		<div class="SessionPopup" >
			<SessionPopup />
		</div>
		<div class="overlay" :class="{ active: 'isOverlayActive' }" v-if="isSessionPopupVisible == true"></div>
		<div class="flex bg-dark" @click="closeApps()">
			<div :class="{ 'w-40': isTogglingData, 'w-10': !isTogglingData ,active:'bg-dark-blue' }">
				<MenuBar />
			</div>
			<div class="content mt-12 flex-1 min-w-0 w-full overflow-hidden" :class="{ toggledstate: isTogglingData }" @scroll="handleScroll">
				<div class="page" :class="getPadding()">
					<slot />
				</div>
				<Footer />
			</div>
		</div>
		<detailsModalHost />
	</div>
</template>
<style scoped>
.content {
	height: calc(100vh - 3rem);
	display: flex;
	flex-direction: column;
	min-height: 0;
}
.page{
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow-y: auto;
	margin-bottom: 0;
	padding-bottom: 30px;
}
.page:has(.page-fill) {
	overflow: hidden;
}
.margin-bottom1 {
	margin-bottom: 0;
}
.margin-bottom2 {
	margin-bottom: 80px;
}
.padding0 {
    margin-bottom: 0px;
}
.SessionPopup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border-radius: 8px;
  z-index: 99999; /* Ensure it's above other content */
}
.bg-dark.active {
  /* background-color:rgba(8, 8, 8, 0.5); */
  opacity:0.7;
  z-index:999;
}
.bg-dark-blue{
	/* background-color:rgba(0, 0, 0, 0.5); */
	opacity: 0.7; 
}
.bg-dark-blue.active{
	/* background-color:rgba(0, 0, 0, 0.5); */
	opacity: 0.7;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); /* Black with opacity */
  z-index: 9999;
  display: none; /* Initially hidden */
}

.overlay.active {
  display: block; /* Show the overlay when active */
}
</style>
<script lang="ts">
import NavBar from '@/components/navBar.vue';
import MenuBar from '@/components/menuBar.vue';
import Footer from '@/components/footer.vue';
import { defineComponent } from 'vue';
import { emitter } from '../main';
import { mapGetters } from 'vuex';
import SessionPopup from '@/components/sessionpopup.vue';
import detailsModalHost from '@/components/detailsModalHost.vue';

export default defineComponent({
	data(): any {
		return {
			isTogglingData: true,
			flag: true,
			isSessionPopupVisible:false
		};
	},
	components: {
		NavBar,
		MenuBar,
		Footer,
		SessionPopup,
		detailsModalHost
	},
	computed: {
		...mapGetters({ userInfo: 'userInfo', toggleState: 'toggle' })
	},
	methods: {
		closeApps() {
			this.appsVisible = false;
			emitter.emit('apps', this.appsVisible);
		},
		handleScroll() {
			if (this.$route.path.includes('/controls/active')|| this.$route.path.includes('/compliance')){
				emitter.emit('close-dropdown'); // Emit event to close dropdown on scroll
			}
		},
		getPadding(){
			if (this.$route.path.includes('/manageControlframeWorks')) {
				return 'padding0'
			}else if(this.$route.name == 'departmentControls'||this.$route.name == 'systemControlMapping'||this.$route.name == 'manageKPI'||this.$route.name=='createCompliance'||this.$route.name=='projectControls'){
				return 'padding0'
			} else {
				return 'margin-bottom1'
			}
		}
	},
	mounted() {
		
		this.isTogglingData = this.toggleState;
		emitter.on('toggle-sidebar', (isToggle) => {
			this.isTogglingData = isToggle;
		});

		


		if (this.$route.path.includes('/manageControlframeWorks')) {
			this.flag = false;
		} else {
			this.flag = true;
		}
	},
	created() {
		emitter.on('sessionPopupVisible',(data:any)=>{
		this.isSessionPopupVisible = data;			
		})
		emitter.on('isvisible',(data:any)=>{						
		this.isSessionPopupVisible = data;	
				
		})
	},
});
</script>
